export const environment = {
  production: false,
  API_BASE_URL: 'https://dev-api.gaulbridge.com/api/v1/',
  SOCKET_URL: 'https://dev-api.gaulbridge.com',
  FX_RATE_ENDPOINT: 'admin/calculator/fx-rate'
};
